
<template>
  <div v-if="formatter.config">
    <div class="agInputGroup agInputGroupCentered">
      <label>Data Type:</label>
      <b-form-select
        class="agMediumInput"
        v-model="formatter.config.dataType"
        :options="dataTypes"
        :disabled="disableUI"
      ></b-form-select>
    </div>
  </div>
</template>






<script>
// components

// modules

export default {
  name: "ag-castFormatter",
  components: {},
  props: {
    disableUI: Boolean,
    formatter: Object
  },
  data() {
    return {
      dataTypes: [
        { value: "boolean", text: "Boolean" },
        { value: "int", text: "Integer" },
        { value: "number", text: "Number" },
        { value: "string", text: "String" }
      ]
    };
  },
  computed: {
    dataType: {
      get: function() {
        if (!this.formatter.config) this.formatter.config = {};
        if (!this.formatter.config.dataType)
          this.formatter.config.dataType = "";
        return this.formatter.config.dataType;
      },
      set: function(value) {
        this.formatter.config.dataType = value;
      }
    }
  },
  watch: {},

  created() {
  },

  mounted() {
    this.reset();
  },

  methods: {
    // UI Events

    // emitted Events

    // other

    reset() {
      
    },

    prepareForSave() {}
  }
};
</script>






<style scoped lang="css">
</style>



// WEBPACK FOOTER //
// src/components/nodes/formatters/CastFormatter.vue